import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useLocation } from '@gatsbyjs/reach-router';
import { get } from 'lodash';

const PortalContainer = ({
  children,
  is404,
  isLeadCollection,
  isLoggedOut,
}) => {
  const { user } = useSelector(({ userProfile }) => ({
    ...userProfile,
  }));

  const location = useLocation();
  const locationPathname = get(location, 'pathname', '');
  const isConfirmationPage = locationPathname.includes('/portal/confirmation'); // This page does not have a portal nav.  Don't show padding.

  return (
    <div
      className={cn({
        'is-portal': !isConfirmationPage,
        'is-404': is404,
        'is-logged-out': isLoggedOut,
        'padding-with-vehicle': user.vehicles.length && !isConfirmationPage,
        'lead-collection': isLeadCollection,
      })}
    >
      {children}
    </div>
  );
};

export default PortalContainer;
